import { render, staticRenderFns } from "./TotalManageTask.vue?vue&type=template&id=6651efa6&"
import script from "./TotalManageTask.vue?vue&type=script&lang=js&"
export * from "./TotalManageTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports